import {linkingMobile} from '../routing/linking';
import {Screens} from '../routing';

const flattenObject = (obj: any) => {
  let toReturn: {[key: string]: string | number} = {};

  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;

    if (typeof obj[i] === 'object' && obj[i] !== null) {
      var flatObject = flattenObject(obj[i]);
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[`${i}.${x}`] = flatObject[x];
      }
    } else {
      toReturn[i] = obj[i];
    }
  }
  return toReturn;
};

const linkingMobileFlatten = flattenObject(linkingMobile.config);
const linkingMobileFlattenKeys = Object.keys(linkingMobileFlatten);

export const isActiveMenu = (menuScreen: string, currentScreen: string): boolean => {
  if (currentScreen === Screens.Main) return false;
  if (menuScreen === currentScreen) {
    return true;
  }

  const res = linkingMobileFlattenKeys.some((item) => {
    const index1 = item.indexOf(`.${menuScreen}.`);
    if (index1 < 0) {
      return false;
    }
    const index2 = item.indexOf(`.${currentScreen}`);

    return index2 > 0;
  });

  return res;
};
